import "sitecss/docutrack.scss";
import * as site from "./site";
export * from "./site";

var noKendoButtons = window.noKendoButtons;

export function postalCodeLookup(postalcode, progressContainer, city, state, nextfield) {
    city = city || $("#City");
    state = state || $("#StateCode");
    nextfield = nextfield || $("#Phone");
    progressContainer = progressContainer || $("form:not('#logoutForm')");
    kendo.ui.progress(progressContainer, true);
    city.removeAttr("disabled");
    state.removeAttr("disabled");

    $.get(window.postalCodeLookupUrl + "/" + postalcode, function (data) {
        if (data != null) {
            city.val(data.City);
            state.val(data.StateCode);
            nextfield.focus();
        } else {
            city.focus();
        }
    }).fail(function () {
        city.focus();
    }).always(function () {
        kendo.ui.progress(progressContainer, false);
    });
}

export function postalCodeEnable(postalcode, city, state) {
    if (postalcode === "") {
        city.attr("disabled", "disabled");
        state.attr("disabled", "disabled");
    } else {
        city.removeAttr("disabled");
        state.removeAttr("disabled");
    }
}

export function gridFilterIconFixEvent(offset?) {
    setTimeout(() => site.gridFilterIconFix(offset), 500);
}

export function isEmpty(value) {
    return typeof value == 'string' && !value.trim() || typeof value == 'undefined' || value === null;
}

function utilInit() {
    site.maskFields();

    $(document).ready(function () {
        //if ($("#bodyContainer").length && $("#footer").length && $("#main-slider-container").length == 0) $("#bodyContainer").css("padding-bottom", $("#footer").outerHeight());
        //resizeAllDropDowns();
        site.enablePlaceholderDropdown();
        if (!(noKendoButtons || false))
            $("input[type='submit'], button")
                .not(".no-k-button")
                .addClass("k-button");
    });

    //$(window).resize(function () {
    //    if ($("#bodyContainer").length && $("#footer").length && $("#main-slider-container").length == 0) $("#bodyContainer").css("padding-bottom", $("#footer").outerHeight());
    //});

    $(document).on("submit", "form", function (evt) {
        var form = this;

        //kendo.ui.progress($(form), true);

        $(form).find(":input").removeAttr("disabled");
        $(form).find("[data-role='datepicker']").each(function () {
            if ($(this).data("kendoDatePicker"))
                $(this).data("kendoDatePicker").enable(true);
        });

        $(form).find("[data-role='numerictextbox']").each(function () {
            if ($(this).data("kendoNumericTextBox"))
                $(this).data("kendoNumericTextBox").enable(true);
        });

        if ($(form).hasClass("noIntercept")) return;

        evt.preventDefault();

        form.submit();
    });

    site.enableSerializeObject();
    site.enableEnterKeypressOnDialog();
    site.enableTextWidth();
    site.enableModalTabbing();
    window.gridFilterIconFixEvent = gridFilterIconFixEvent;
    window.utilLoaded = true;
    $(document).trigger("utilLoad");
}

export let VehicleBodyTypeEnum = {
    Minivan: 1,
    FullSizeVan: 2,
    Suv: 3,
    Truck: 4,
    Bus: 5,
    CutAway: 6
}

utilInit();
